export default __webpack_public_path__ + "media/Bamboo_tablet.3469bc366b6822fbd3412edecb1b35db.svg";